import "./assets/style/tailwind.css";
import "ant-design-vue/dist/reset.css";
import "./assets/style/vars.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import dayjs from "dayjs";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Antd from "ant-design-vue";
// import "ant-design-vue/dist/antd.min.css";

NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: true, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3, // 初始化时的最小百分比
});
router.beforeEach((to, from, next) => {
  // 每次切换页面时，调用进度条
  NProgress.start();

  // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
  next();
});
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done();
});

let app = createApp(App);

app.config.globalProperties.$dateFormat = "DD/MM/YYYY";
app.config.globalProperties.$timeFormat = timeFormat;
app.config.globalProperties.$getFileName = getFileName;
app.config.globalProperties.$toTimeStamp = toTimeStamp;
app.config.globalProperties.$timeLocaleFormat = timeLocaleFormat;
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$publicPath = process.env.BASE_URL;
app.config.globalProperties.$firstUpperCase = firstUpperCase;
app.config.globalProperties.$onlyFirstUpperCase = onlyFirstUpperCase;
app.config.globalProperties.$componentSize = "small";

app.use(router).use(store).use(Antd).mount("#app");

function timeFormat(t, hm, s) {
  if (!t) {
    return "";
  }
  if (typeof t != "number") {
    return t;
  }
  if (s) {
    t = t / 1000;
  }
  let d = new Date(t * 1000);
  let day = d.getDate();
  let m = d.getMonth() + 1;
  let y = d.getFullYear();
  if (day.toString().length == 1) {
    day = "0" + day.toString();
  }
  if (m.toString().length == 1) {
    m = "0" + m.toString();
  }
  let h = d.getHours();
  let mn = d.getMinutes();
  if (h.toString().length < 2) {
    h = "0" + h;
  }
  if (mn.toString().length < 2) {
    mn = "0" + mn;
  }
  if (hm) {
    return `${day}/${m}/${y} ${h}:${mn}`;
  }
  return `${day}.${m}.${y}`;
}

function timeLocaleFormat(t) {
  if (!t) {
    return "";
  }
  if (typeof t != "number") {
    return t;
  }
  let d = new Date(t * 1000);
  let day = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Almaty",
    hour12: false,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(d);

  return day;
}

function getFileName(url) {
  if (url && typeof url === "string") {
    if (url.indexOf("/") == -1) {
      return url;
    }
    return url.split("/")[url.split("/").length - 1];
  } else {
    return "";
  }
}

function toTimeStamp(time) {
  let e = time || 0;
  if (e) {
    return (dayjs(e).valueOf() / 1000).toFixed(0) * 1;
  } else {
    return e;
  }
}

function firstUpperCase(word) {
  if (!word || typeof word != "string") {
    return "";
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
}

function onlyFirstUpperCase(word) {
  if (!word || typeof word != "string") {
    return "";
  }
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
